// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".earlyPurchaseDetails {\n  margin-top: 15px;\n  margin-left: 35px;\n}\n.availableDiscounts {\n  margin-top: 30px;\n}\n.discountLine {\n  margin: 25px 0;\n  display: flex;\n  align-items: center;\n}\n.discountLine div {\n  flex: 1;\n}\n.discountSelector {\n  margin-top: 15px;\n}", ""]);
// Exports
module.exports = exports;
